"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  counterMenu: {
    display: 'flex',
    alignItems: 'center',
    '& label': {
      fontFamily: _theme.default.typography.proxima.regular,
      fontSize: _theme.default.typography.pxToRem('14'),
      lineHeight: _theme.default.typography.pxToRem('18')
    },
    [_theme.default.breakpoints.down('sm')]: {
      '& label': {
        fontSize: _theme.default.typography.pxToRem('16'),
        lineHeight: '150%'
      }
    }
  },
  dropLabel: {
    paddingLeft: '30px',
    height: 'auto',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: _theme.default.palette.primary.light,
    '& svg': {
      paddingLeft: '10px'
    },
    '& span': {
      fontSize: '14px'
    }
  },
  menu: {
    padding: '20px'
  },
  [_theme.default.breakpoints.down('sm')]: {
    paper: {
      width: 'calc(100% - 40px)',
      left: '20px !important'
    }
  },
  wrapperCounter: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontFamily: _theme.default.typography.proxima.regular,
      marginBottom: 30,
      marginRight: 40
    },
    '& span': {
      fontFamily: _theme.default.typography.proxima.regular,
      fontSize: _theme.default.typography.pxToRem('32'),
      lineHeight: _theme.default.typography.pxToRem('39')
    }
  },
  counter: {
    display: 'flex',
    width: 150,
    height: 72,
    alignItems: 'center',
    marginBottom: 30,
    float: 'right',
    backgroundColor: _theme.default.palette.grayScale.light,
    '& svg': {
      fill: _theme.default.palette.primary.light
    }
  },
  footerMenu: {
    textAlign: 'right',
    '& button': {
      color: _theme.default.palette.primary.light,
      [_theme.default.breakpoints.down('sm')]: {
        width: 'auto'
      }
    }
  },
  disabledButton: {
    backgroundColor: "".concat(_theme.default.palette.grayScale.light, " !important"),
    '& svg': {
      fill: _theme.default.palette.grayScale.disabled
    }
  }
});
var _default = exports.default = useStyles;